import { getPaymentType } from "@/apis/user";
import { Payments } from "@/constants";
import { LogStore } from "@/libs/logger";
import { List, PaymentType } from "@/types/Api/User/PaymentType";
import { create } from "zustand";
import * as Sentry from '@sentry/react';

interface PaymentsStore {
  payments: Payments[];
  paymentList: PaymentType["response"]["list"];
  formatPayments: Record<Payments, formatPaymentValue | undefined>;
  setPayments: (paymentList: PaymentType["response"]["list"]) => void;
  updatePayments: () => void;
}
export type formatPaymentListItem = {
  id: number;
  province: string;
  city: string;
  realName: string;

  receiptCode?: string;
  alipayAccount?: string;
  wxRealname?: string;

  logoImg?: string;
  bankBranch?: string;
  bankNo?: string;
  bankId?: string;

  isMerchant?: boolean,

  digitalAddress?: string
  
};
export interface formatPaymentValue {
  type: number;
  typeName: string;
  list: formatPaymentListItem[];
}

const format = (list: PaymentType["response"]["list"]) => {
  const formatPayments: Record<Payments, formatPaymentValue | undefined> = {
    [Payments.BANK]: undefined,
    [Payments.ALI]: undefined,
    [Payments.WE_CHAT]: undefined,
    [Payments.CRYPTO_COIN]: undefined,
    [Payments.DIGITAL_RMB]: undefined,
    [Payments.WX_GROUP]: undefined
  };
  const payments: Payments[] = [];
  try {
    list.forEach((item: List) => {
      
      const value = formatPayments[item.type as Payments];
      if (value === undefined) {
        payments.push(item.type);
        formatPayments[item.type as Payments] = {
          type: item.type,
          typeName: item.typeName,
          list: [{ 
            id: item.id, ...JSON.parse(item.info), 
            isMerchant: item.ownerType === 'Business', 
            isProfession: item.ownerType ==="ProfessionBusiness",
          }],
        };
      } else {
        value.list.push({ 
          id: item.id, ...JSON.parse(item.info), 
          isMerchant: item.ownerType === 'Business', 
          isProfession: item.ownerType ==="ProfessionBusiness",
        });
        formatPayments[item.type as Payments] = value;
      }
    });
  } catch (error) {
    // TODO: JSON解析错误需要上报

    Sentry.captureException(new Error(`解析用户支付列表失败`));
    console.error(...LogStore.error("解析用户支付列表失败"));
  }
  console.log(payments, formatPayments)
  return {
    payments,
    formatPayments,
  };
};

export const usePaymentsStore = create<PaymentsStore>((set) => ({
  payments: [],
  paymentList: [],
  formatPayments: {
    [Payments.BANK]: undefined,
    [Payments.ALI]: undefined,
    [Payments.WE_CHAT]: undefined,
    [Payments.CRYPTO_COIN]: undefined,
    [Payments.DIGITAL_RMB]: undefined,
    [Payments.WX_GROUP]: undefined
  },
  setPayments: (paymentList) => {
    const { formatPayments, payments } = format(paymentList);
    set(() => ({
      payments,
      paymentList,
      formatPayments: formatPayments as Record<
        Payments,
        formatPaymentValue | undefined
      >,
    }));
  },
  updatePayments: async () => {
    const bankResponse = await getPaymentType({});
    if (bankResponse.ok) {
      const list = bankResponse.data?.list || [];
      const { formatPayments, payments } = format(list);
      set(() => ({
        payments,
        paymentList: list,
        formatPayments: formatPayments as Record<
          Payments,
          formatPaymentValue | undefined
        >,
      }));
    } else {
      // TODO: 上报获取银行卡失败

      Sentry.captureException(new Error(`获取用户支付列表失败`));
      console.error(...LogStore.error("获取用户支付列表失败"));
    }
    return bankResponse;
  },
}));
